import { MAX_WIDTH as p } from "../constants.js";
const $ = (t, e, o) => {
  let l = e === "100%" ? e : `${t || p}px`;
  return e === "100%" && o && (l = `${p}px`), {
    width: l,
    maxWidth: e === "100%" ? e : `min(100%, ${Math.max(p, t || 0)}px)`
  };
}, n = (t) => ({
  height: t ? `${t}px` : "auto"
}), s = (t, e, o) => {
  let l;
  return t && e ? l = `${t} / ${e}` : o && (l = `${o} / 1`), {
    aspectRatio: l
  };
};
export {
  s as getAspectRatioStyle,
  n as getHeightStyle,
  $ as getWidthStyle
};
